// extracted by mini-css-extract-plugin
export default {"card":"Card_card__yHOaw","interactive":"Card_interactive__-gYAH"};